"use client"

import { useEffect, useState } from "react"

const CONSENT_COOKIE = "cp_analytics_consent"
const CONSENT_STORAGE_KEY = "cp_analytics_consent"
const TTL_SECONDS = 60 * 60 * 24 * 180 // 6 mois

function setConsent(value: "accepted" | "refused") {
  const secureAttr = window.location.protocol === "https:" ? "; Secure" : ""
  document.cookie = `${CONSENT_COOKIE}=${value}; Path=/; Max-Age=${TTL_SECONDS}; SameSite=Lax${secureAttr}`
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, value)
  } catch {
    // no-op
  }
}

function getConsent(): "accepted" | "refused" | null {
  const cookieMatch = document.cookie
    .split("; ")
    .find((part) => part.startsWith(`${CONSENT_COOKIE}=`))

  const cookieValue = cookieMatch?.split("=")[1]
  if (cookieValue === "accepted" || cookieValue === "refused") {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, cookieValue)
    } catch {
      // no-op
    }
    return cookieValue
  }

  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
    if (stored === "accepted" || stored === "refused") return stored
  } catch {
    // no-op
  }

  return null
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(getConsent() === null)
  }, [])

  if (!visible) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-[9999] border-t border-white/15 bg-[#0d0a07]/95 px-4 py-3 backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <p className="text-xs leading-relaxed text-white/80">
          Nous utilisons des mesures d&apos;audience pour améliorer le site. Aucune géolocalisation GPS n&apos;est
          demandée sans action explicite.
        </p>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => {
              setConsent("refused")
              setVisible(false)
            }}
            className="h-9 border border-white/25 px-3 text-xs font-medium text-white/90 transition hover:border-white/45"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={() => {
              setConsent("accepted")
              setVisible(false)
            }}
            className="h-9 bg-[#e8620a] px-3 text-xs font-medium text-black transition hover:bg-[#ff7b26]"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  )
}
